import * as React from "react";
import { List } from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import { urlWithProtocol } from "helpers/globalFunctions";
import styled from "styled-components";
import ILocation from "api/types/utils/ILocation";

import Typography, {
  definedTypography,
} from "../../atoms/Typography/Typography";

export interface ContactDetailListProps {
  phone?: string[] | string;
  email?: string[] | string;
  website?: string;
  address?: ILocation | null;
  occupation?: string;
  field?: string;
}

const StyledContent = styled(List.Content)({
  "&&&": { paddingTop: "0.2em !important" },
});

const ContactDetailList: React.FC<ContactDetailListProps> = ({
  address,
  phone,
  email,
  website,
  occupation,
  field,
}) => {
  const { t } = useTranslation();
  const mail = typeof email === "string" ? [email] : email;
  const number = typeof phone === "string" ? [phone] : phone;

  return (
    <List>
      {field && (
        <List.Item>
          <List.Icon
            name="building outline"
            color="black"
            size="large"
            style={{ width: "21px" }}
          />
          <StyledContent>
            <Typography type={definedTypography.caption}>{field}</Typography>
          </StyledContent>
        </List.Item>
      )}
      {occupation && (
        <List.Item>
          <List.Icon name="user outline" color="black" size="large" />
          <StyledContent>
            <Typography type={definedTypography.caption}>
              {occupation}
            </Typography>
          </StyledContent>
        </List.Item>
      )}
      {website && (
        <List.Item key={website}>
          <List.Icon name="world" color="black" size="large" />
          <StyledContent>
            <Typography type={definedTypography.caption}>
              <a
                href={urlWithProtocol(website)}
                rel="noopener noreferrer"
                target="_blank"
              >
                {website}
              </a>
            </Typography>
          </StyledContent>
        </List.Item>
      )}
      {mail?.map((item) => (
        <List.Item key={item}>
          <List.Icon name="mail" color="black" size="large" />
          <StyledContent>
            <Typography type={definedTypography.caption}>{item}</Typography>
          </StyledContent>
        </List.Item>
      ))}
      {number?.map((item) => (
        <List.Item key={item}>
          <List.Icon name="phone" color="black" size="large" />
          <StyledContent>
            <Typography type={definedTypography.caption}>{item}</Typography>
          </StyledContent>
        </List.Item>
      ))}
      <List.Item>
        <List.Icon
          name="map marker alternate"
          id="address"
          color="black"
          size="big"
          style={{
            fontSize: "1.7em",
          }}
        />
        <StyledContent>
          <Typography type={definedTypography.caption}>
            {address?.address || t("NoPlace")}
          </Typography>
        </StyledContent>
      </List.Item>
    </List>
  );
};

export default ContactDetailList;
